import React, { useState, useEffect, useRef } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import ReportDetails from "./components/ReportDetails";
import DriverAnalytic from "./components/DriverAnalytic";
import Header from "./components/Header";
import FilterTabs from './admin/components/FilterTabs';
import DriversView from './admin/pages/DriversView';
import { MdAutoAwesome, MdFilterAlt } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { setCredentials, logOut } from "./features/auth/authSlice";
import { setEntityId, clearAccountData } from "./features/account/accountSlice";
import { APP_BASE_URL } from "./config/api";
import useActivityStatus from "./hooks/useActivityStatus";
// import { useAccount } from "./context/AccountContext";

const ACTIVITY_TIMEOUT_ENV = process.env.REACT_APP_ACTIVITY_TIMEOUT || 120;
const ACTIVITY_TIMEOUT = parseInt(ACTIVITY_TIMEOUT_ENV, 10);

const ViewerApp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, token, isAuthenticated, isLoading, error } = useSelector((state) => state.auth);
  const { accountId, entityId, loading: accountLoading, error: accountError } = useSelector((state) => state.account);
  console.log("state user : ", user);
  console.log("state token : ", token);
  console.log("state isAuthenticated : ", isAuthenticated);
  // const [accountId, setAccountId] = useState(null);
  // const { accountId, entity_id } = useAccount();
  console.log("viewer account id:", accountId);
  // Add these state declarations at the top with other states
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  // State to manage selected key and value for report details
  const [recordContext, setRecordContext] = useState(null);
  // State to manage current view and right sidebar content. Default Set to analytic
  // This state determines which main view is currently active (e.g., 'analytic' or 'drivers').
  const [currentView, setCurrentView] = useState('analytic');
  // State to manage right sidebar content. Default Set to details 
  // This state determines what content is displayed in the right sidebar (e.g., 'details' or 'rules').
  const [rightSidebarContent, setRightSidebarContent] = useState('details');
  // Extract driver_id, entity_id, and sub_entity_id from URL parameters
  // This allows the component to initialize with specific driver and entity IDs from the URL.
  // useParams is a hook from react-router-dom that extracts parameters from the current URL.
  // It returns an object containing the parameters defined in the route path.
  // In this case, it extracts driver_id, entity_id, and sub_entity_id from the URL.
  // This is useful for dynamically loading data based on the URL.

  const { driver_id: urlDriverId, entity_id: urlEntityId, sub_entity_id: urlSubEntityId } = useParams();
  // Initialize state with URL parameters or default values
  const [driver_id, setDriverId] = useState(urlDriverId);
  // Default to 1 if no entity_id or sub_entity_id is provided
  // const [entity_id, setEntityId] = useState(urlEntityId || 1);
  const [sub_entity_id, setSubEntityId] = useState(urlSubEntityId || 1);

  // State to manage report data and selected record
  const [reportData, setReportData] = useState(null);

  // State to manage selected key and value for report details
  //When Violations or Messages are clicked, this state will be updated with the selected record's key and value.
  // This state is used to display detailed information about the selected record in the right sidebar.
  // It holds the key and value of the selected record, which will be displayed in the ReportDetails component.
  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);

  // State to manage visibility of the banner and score data
  const [showBanner, setShowBanner] = useState(false);
  // State to manage score data
  const [scoreData, setScoreData] = useState(null);
  // Refs for scrolling and scorer component
  const scorerRef = useRef(null);
  // Ref for main content area to handle scroll events
  const mainRef = useRef(null);

  const [searchItem, setSearchItem] = useState("");

  const isActive = useActivityStatus(ACTIVITY_TIMEOUT);

  useEffect(() => {
    if (isActive === false) {
      return;
    }
    const verifyToken = async (tokenToVerify) => {
      if (!tokenToVerify) {
        dispatch(clearAccountData());
        dispatch(logOut());
        navigate('/');
        return;
      }

      try {
        const response = await fetch(APP_BASE_URL + `/api/verify/token/${tokenToVerify}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        if (data && typeof data === "object" && ("verify" in data)) {
          if (data.verify === false) {
            localStorage.removeItem("token");
            dispatch(clearAccountData());
            dispatch(logOut());
            navigate('/');
            return;
          }
          if (data.user && data.user.account_id) {
            if (!isAuthenticated || user.account_id !== data.user.account_id) {
              dispatch(setCredentials({ user: data.user, token: tokenToVerify }));
              dispatch(setEntityId(data.user.account_id)); // Assuming entity_id is account_id
            }
          }
        }
      } catch (err) {
        console.error("Error during token verification in ViewerApp:", err);
        localStorage.removeItem("token");
        dispatch(clearAccountData());
        dispatch(logOut());
        navigate('/');
      }
    };

    let tokenToUse = localStorage.getItem("token");
    if (!tokenToUse && isAuthenticated && token) {
      tokenToUse = token;
    }

    if (!tokenToUse && !isAuthenticated) {
      dispatch(clearAccountData());
      dispatch(logOut());
      navigate('/');
      return;
    }

    if (tokenToUse) {
      verifyToken(tokenToUse);
    }

  }, [dispatch, navigate, isAuthenticated, token, user, APP_BASE_URL,isActive]);

  useEffect(() => {
    const fetchReport = async () => {
      console.log("fetchReport call :", driver_id);
      try {
        const response = await fetch(`${APP_BASE_URL}/report?driver_id=${driver_id}`);
        const data = await response.json();
        console.log("📥 Fetched Report Data:", data);
        setReportData(data);
      } catch (error) {
        console.error("❌ Error fetching report:", error);
      }
    };

    if (driver_id) {
      fetchReport();
    }
  }, [driver_id]);

  // Handle score updates from the DriverAnalytic component
  const handleScoreUpdate = (newScore) => {
    setScoreData(newScore);
    // Remove automatic banner show
    // setShowBanner(true); 
  };


  // Optimized scroll handler
  useEffect(() => {
    // This effect sets up a scroll event listener on the main content area
    // It checks if the scorer component is above the viewport and updates the showBanner state accordingly
    const handleScroll = () => {
      if (scorerRef.current && mainRef.current) {
        const rect = scorerRef.current.getBoundingClientRect();
        // Show banner when scorer component moves above viewport
        setShowBanner(rect.top < 0);
      }
    };
    // Attach scroll event listener to the main content area
    const mainElement = mainRef.current;
    if (mainElement) {
      mainElement.addEventListener('scroll', handleScroll);
      // Initial check
      handleScroll();
      return () => mainElement.removeEventListener('scroll', handleScroll);
    }
  }, []);

  // Function to handle toggling the right sidebar content
  // This function updates the right sidebar content based on user interaction
  // It can be used to switch between 'details' and 'rules' views. Passed as content
  // This function is called when the user clicks on the sidebar content toggle button.
  // It sets the rightSidebarContent state to the specified content type.
  // This allows the user to switch between different views in the right sidebar.
  const handleSidebarContentToggle = (content) => {
    setRightSidebarContent(content);
  };

  // Function to handle toggling between 'rules' and 'details' in the right sidebar
  // This function is called when the user clicks on the toggle button in the header.
  // It checks the current content and toggles it between 'rules' and 'details'.
  // This allows the user to switch between viewing rules and report details in the right sidebar.
  const handleToggleRules = () => {
    // Toggle between 'rules' and 'details'
    setRightSidebarContent(current => current === 'rules' ? 'details' : 'rules');
  };
  // Function to handle record selection in the DriverAnalytic component
  // This function is called when a record is selected in the DriverAnalytic component.
  // It updates the selectedKey, selectedValue, and recordContext states with the data from the selected record.
  const handleRecordSelect = (recordData) => {
    if (!recordData) return;
    setRightSidebarContent('details');
    setSelectedKey(recordData.key);
    setSelectedValue(recordData.value);
    setRecordContext(recordData.context);
  };
  // Function to handle viewing analytics for a specific driver
  // This function is called when the user clicks on a driver to view their analytics.
  // It updates the current view to 'analytic' and sets the driver_id, entity_id, and sub_entity_id states.
  const handleViewAnalytics = async (newDriverId) => {
    try {
      setLoading(true);

      // Update view and IDs
      setCurrentView('analytic');
      setDriverId(newDriverId);
      // setSubEntityId(newSubEntityId);

      // Clear existing data
      setReportData(null);
      setSelectedKey(null);
      setSelectedValue(null);
      setRecordContext(null);
      setScoreData(null);

      // Fetch report data
      const response = await fetch(`${APP_BASE_URL}/report?driver_id=${newDriverId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch report data');
      }

      const data = await response.json();
      console.log("📥 Fetched Report Data:", data);

      // Update state with new data
      setReportData(data);
      setLoading(false);

      return true;

    } catch (error) {
      console.error('Error in handleViewAnalytics:', error);
      setLoading(false);
      // setError(error.message);
      throw error;
    }
  };

  const handleSearch = (item) => {
    setSearchItem(item);
    // When search is performed, ensure we are in the drivers view
    if (item && item.trim() !== '') {
      setCurrentView('drivers');
    }
  };

  const [searchParams] = useSearchParams();
  const initialView = searchParams.get('view');
  const [defaultView, setDefaultView] = useState(initialView || 'default');

  useEffect(() => {
    setCurrentView(initialView);
     if (initialView === 'analytic') {
       if(searchParams.get('driver_id')){
        handleViewAnalytics(searchParams.get('driver_id'));
       }
      }

    // if (initialView === 'drivers') {
    //   setCurrentView('drivers');
    // } else if (initialView === 'recentDrivers') {
    //   setCurrentView('recentDrivers');
    // } else if (initialView === 'completedDrivers') {
    //   setCurrentView('completedDrivers');
    // }else if (initialView === 'analytic') {
    //   setCurrentView('analytic');
    // }
  }, [initialView,searchParams]);

  return (
    <div className="h-screen flex flex-col text-[13px] font-sans">
      <div className="flex flex-1 overflow-hidden">
        {/* Left Sidebar - Fixed width and proper flex */}
        <aside className="w-60 bg-gray-50 border-r border-gray-200 flex-shrink-0">
          <Sidebar />
        </aside>

        {/* Main Container - Proper flex layout */}
        <div className="flex flex-col flex-1 min-w-0">
          {/* Fixed Header - Consistent height */}
          <header className="h-16 border-b border-gray-200 bg-white flex items-center px-6 flex-shrink-0">
            <Header
              onToggleRules={handleToggleRules}
              isRulesActive={rightSidebarContent === 'rules'}
              onNavigateToDrivers={() => setCurrentView('drivers')}
              onSearch={handleSearch}
            />
          </header>

          {/* Content Area - Proper flex and overflow handling */}
          <div className="flex flex-1 overflow-hidden">
            {/* Main Content - Proper flex basis */}
            <main className="flex-1 overflow-hidden min-w-0">
              {currentView === 'drivers' || currentView === 'recentDrivers' || currentView === 'completedDrivers' ? (
                <div className="h-full overflow-y-auto">
                  <DriversView onViewAnalytics={handleViewAnalytics} searchItem={searchItem} />
                </div>
              ) : currentView === 'analytic' ? (
                <DriverAnalytic
                  ref={mainRef}
                  reportData={reportData}
                  driver_id={driver_id}
                  entity_id={entityId}
                  sub_entity_id={sub_entity_id}
                  onScoreUpdate={handleScoreUpdate}
                  setSelectedKey={setSelectedKey}
                  setSelectedValue={setSelectedValue}
                  onRecordSelect={handleRecordSelect}
                  showBanner={showBanner}
                  scoreData={scoreData}
                  scorerRef={scorerRef}
                  onToggleFilters={handleToggleRules}
                />
              ) : null}
            </main>
            {/* Right Sidebar - Fixed width and proper flex */}
            <aside className={`w-80 border-l flex-shrink-0 transition-colors ${
              rightSidebarContent === 'rules'
                ? 'border-teal-200 bg-teal-50/30'
                : 'border-gray-200 bg-white'
            }`}>
              <div className="h-full flex flex-col">
                {rightSidebarContent === 'details' ? (
                  <ReportDetails
                    selectedKey={selectedKey}
                    selectedValue={selectedValue}
                    recordContext={recordContext}
                  />
                ) : (
                  <div className="flex flex-col h-full">
                    {/* Teal header bar for filters */}
                    <div className="px-4 py-2 bg-teal-100 border-b border-teal-200">
                      <div className="flex items-center gap-2">
                        <MdFilterAlt className="text-teal-600" size={16} />
                        <span className="text-sm font-semibold text-teal-700">Scoring Filters</span>
                      </div>
                    </div>
                    <div className="flex-1 overflow-y-auto bg-white">
                      <FilterTabs />
                    </div>
                    <div className="border-t border-teal-200 flex-shrink-0">
                      <button
                        onClick={() => handleSidebarContentToggle('details')}
                        className="w-full px-4 py-3 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex items-center gap-2">
                          <MdAutoAwesome className="text-teal-600" size={16} />
                          <span className="text-sm font-medium text-gray-700">
                            Smart Details
                          </span>
                        </div>
                        {selectedKey && (
                          <span className="text-xs text-gray-500">
                            Click to expand
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </aside>
          </div>
        </div>
      </div>

      {/* Footer - Fixed at bottom */}
      <Footer />
    </div>
  );
};

export default ViewerApp;